import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    userDrawerStatus: false,
    fileOpenerStatus : false,
    codeDrawerStatus: false,
    contentDrawerStatus: false,
    slideInStatus: false,
    progressTrigger: false,
    multiDrawerStatus: {},
    refreshContent: false,
    refreshNotification: false,
    refreshRentalRequest: false,
}

const statusSlice = createSlice({
    name: "openDrawer",
    initialState,
    reducers: {
        changeUserDrawerStatus: (state, action) => {
            // if (action.payload) document.body.style.overflow = "hidden";
            // else document.body.style.overflow = "auto";
            state.userDrawerStatus = action.payload;
        },
        changeFileOpenerStatus: (state, action) => {
            state.fileOpenerStatus = action.payload;
        },
        changeCodeDrawerStatus: (state, action) => {
            if (action.payload) document.body.style.overflow = "hidden";
            else document.body.style.overflow = "auto";
            state.codeDrawerStatus = action.payload;
        },
        changeContentDrawerStatus: (state, action) => {
            // if (action.payload) document.body.style.overflow = "hidden";
            // else document.body.style.overflow = "auto";
            state.contentDrawerStatus = action.payload
        },
        changeSlideInStatus: (state, action) => {
            state.slideInStatus = action.payload;
        },
        changeProgressTrigger: (state, action) => {
            state.progressTrigger = action.payload;
        },
        changeMultiDrawerStatus: (state, action) => {
            // action.payload에 true, false가 아닌 객체가 들어온다. else로 돌아가지 않음
            // if (action.payload) document.body.style.overflow = "hidden";
            // else document.body.style.overflow = "auto";
            state.multiDrawerStatus = {...action.payload}
        },
        changeRefreshContentStatus: (state, action) => {
            state.refreshContent = !state.refreshContent;
        },
        changeRefreshNotificationStatus: (state, action) => {
            state.refreshNotification = !state.refreshNotification;
        },
        changeRefreshRentalRequest: (state, action) => {
            state.refreshRentalRequest = !state.refreshRentalRequest;
        },
        changeRefreshContentAndRentalRequest: (state, action) => {
            state.refreshRentalRequest = !state.refreshRentalRequest;
            state.refreshContent = !state.refreshContent;
        }
    }
});

export const {
    changeUserDrawerStatus,
    changeFileOpenerStatus,
    changeCodeDrawerStatus,
    changeContentDrawerStatus,
    changeSlideInStatus,
    changeProgressTrigger,
    changeMultiDrawerStatus,
    changeRefreshContentStatus,
    changeRefreshNotificationStatus,
    changeRefreshRentalRequest,
    changeRefreshContentAndRentalRequest,
} = statusSlice.actions;
export default statusSlice.reducer;